{
    "NAME": "Linguaggio dell'elenco di gestione dei log",
    "LogManagementList_Column_Name": "File di registro",
    "LogManagementList_Column_ClassName": "Per la classe",
    "LogManagementList_Column_FileName": "Nome file",
    "LogManagementList_Column_FileSize": "Dimensione del file",
    "LogManagementList_Column_Status": "Stato",
    "LogManagementList_Status_Running": "Corsa",
    "LogManagementList_Status_NotRunning": "Non in esecuzione",
    "LogManagementList_Action_Start": "Inizio",
    "LogManagementList_Action_Stop": "Fermare",
    "LogManagementList_Action_Reset": "Reset",
    "LogManagementList_Action_Download": "Scaricamento",
    "LogManagementList_SearchPlaceholder": "[File di registro]",
    "LogManagementList_Empty": "Al momento non vengono visualizzati elementi di registro, il che probabilmente indica un problema critico di inizializzazione dell'applicazione o di un componente interno.",
    "LogManagementList_Confirm_ResetTitle": "Reimposta i file di registro",
    "LogManagementList_Confirm_ResetBody": "Attenzione: la scelta di reimpostare uno o più elementi del file di registro eliminerà i file corrispondenti, operazione irreversibile.",
    "LogManagementList_Confirm_StopTitle": "Interrompi la registrazione",
    "LogManagementList_Confirm_StopBody": "La scelta di interrompere temporaneamente la generazione dell'output di log nel\/nei file di log selezionati dovrebbe essere effettuata solo quando è necessario bloccare i file corrispondenti in situazioni particolari.",
    "LogManagementList_Confirm_Generic": "Desideri davvero continuare ed eseguire l'azione selezionata?"
}